define( function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/support.js
 ** module id = 78
 ** module chunks = 0
 **/